import { Models } from "api/types";

export interface VariantButtonProps {
  variant: Models<"DisplayShopRetailProductVariant">;
  isSelected: boolean;
  onSelect: (variantId: string) => void;
  productName?: string;
}

export const VariantButton = ({
  variant,
  isSelected,
  onSelect,
  productName,
}: VariantButtonProps) => {
  const variantName = variant.name.text;

  // Hide variant name if it matches the product name or is "Default Title"
  if (
    (productName && variantName === productName) ||
    variantName === "Default Title"
  ) {
    return null;
  }

  const getButtonStyles = () => {
    const baseStyles =
      "rounded-md border px-3 py-1 text-sm font-bold transition-colors duration-200 whitespace-nowrap flex-shrink-0";

    if (isSelected) {
      return `${baseStyles} border-brand-color bg-brand-color text-white`;
    }

    return `${baseStyles} border-brand-color bg-white text-gray-800 hover:bg-brand-color/10`;
  };

  return (
    <button
      key={variant.id}
      onClick={() => onSelect(variant.id)}
      className={`${getButtonStyles()}`}
    >
      {variantName}
    </button>
  );
};
